<script>
import { mapState } from "vuex";
import Membership from "../pages/users/Membership.vue";
import { redirectToLogout } from "../../oauth";

export default {
  components: {
    Membership,
  },
  data() {
    return {
      isMembershipVisible: false,
    };
  },
  methods: {
    async logout() {
      this.isMembershipVisible = false;
      await this.$store.dispatch("clearUserToken");
      redirectToLogout();
    },
    showMembership() {
      this.isMembershipVisible = true;
    },
    membershipClosed() {
      this.isMembershipVisible = false;
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.auth.userData,
    }),
  },
};
</script>

<template>
  <div class="user-info" v-if="this.userData" @click="showMembership">
    <div class="user-avatar"></div>
    <div class="user-stack">
      <div class="user-name">{{ this.userData.name }}</div>
    </div>
    <Membership
      v-if="isMembershipVisible"
      :user="userData"
      :showLogout="true"
      @closed="membershipClosed"
      @logout="logout"
    />
  </div>
</template>

<style lang="scss" scoped>
.user-info {
  display: flex;
  align-items: center;
}

.user-avatar {
  flex: 0 0 auto;
  margin-right: 0.5rem;

  width: 2.75rem;
  height: 2.75rem;
  background: #DDDDDD;
  border-radius: 100%;
}

.user-stack {
  flex: 1 0 auto;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-items: center;
}

.user-name {
  margin-bottom: 0.125rem;
  font-size: 0.875rem;
}

.user-actions {
  font-size: 0.75rem;

  a:link, a:visited {
    color: #EB5757;
    text-decoration: none;
  }

  a:active, a:hover {
    color: #EB5757;
    text-decoration: underline;
  }
}

::v-deep .mdc-dialog__surface footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

::v-deep .mdc-dialog__surface footer > * {
  margin-left: 1.5rem;
}

::v-deep .mdc-dialog__surface footer button {
  background: transparent;
  border: 1px solid #1275CC;
  color: #1275CC;
  border-radius: 4px;
  padding: 0.75rem 1.5rem !important;
  font-weight: bold;
  cursor: pointer;
  line-height: 1.6rem;
  font-size: 1rem !important; // Increased font-size
  box-sizing: border-box !important;
  width: auto !important; // Add this line

  &.primary {
    background: #1275CC !important;
    border-color: transparent !important;
    color: white !important;
  }
}
</style>
